// src/utils/api.js
import config from './config';

const handleResponse = async (response) => {
  if (!response.ok) {
    const clonedResponse = response.clone();
    try {
      const errorData = await response.json();
      throw new Error(errorData.error || errorData.message || 'API request failed');
    } catch (e) {
      const errorText = await clonedResponse.text();
      throw new Error(errorText || 'API request failed');
    }
  }
  return response.json();
};

const getApiUrl = (endpoint) => {
  const baseUrl = config.api.baseUrl;
  const formattedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${formattedEndpoint}`;
};

export const apiUtils = {
  getApiUrl,
  handleResponse,
  // makeRequest: async (endpoint, options = {}) => {
  //   const url = getApiUrl(endpoint);
  //   try {
  //     const response = await fetch(url, {
  //       ...options,
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Accept: 'application/json',
  //         ...options.headers
  //       }
  //     });
  //     return handleResponse(response);
  //   } catch (error) {
  //     console.error('API Request Error:', error);
  //     throw new Error(`API request failed: ${error.message}`);
  //   }
  // }
  makeRequest: async (endpoint, options = {}) => {
    const url = getApiUrl(endpoint);
    try {
      const isFormData = options.body instanceof FormData;
      const headers = {
        Accept: 'application/json',
        ...options.headers
      };

      // Don't set Content-Type for FormData
      if (!isFormData) {
        headers['Content-Type'] = 'application/json';
      }

      const response = await fetch(url, {
        ...options,
        headers,
        body: options.body
      });

      return handleResponse(response);
    } catch (error) {
      console.error('API Request Error:', error);
      throw new Error(`API request failed: ${error.message}`);
    }
  }
};
